import styled, { keyframes } from 'styled-components';
import { colors } from '../../../utils/utils';

// A short "ringing" wiggle that repeats with a pause between bursts.
const phoneShake = keyframes`
    0%, 50%, 100% { transform: rotate(0deg); }
    55% { transform: rotate(-15deg); }
    60% { transform: rotate(12deg); }
    65% { transform: rotate(-10deg); }
    70% { transform: rotate(8deg); }
    75% { transform: rotate(-5deg); }
    80% { transform: rotate(0deg); }
`;

export const Screen = styled.div`
    position: fixed;
    inset: 0;
    z-index: 120;
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    padding: 28px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: linear-gradient(180deg, ${colors.blue.royal_blue} 0%, ${colors.blue.dark_blue} 100%);
    color: ${colors.white.basic};
`;

export const LogoSlot = styled.div`
    margin-bottom: 28px;
`;

export const IconBadge = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 104px;
    height: 104px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    margin-bottom: 24px;

    /* Shake just the phone glyph, not the surrounding circle. */
    svg {
        transform-origin: 50% 50%;
        animation: ${phoneShake} 2.2s ease-in-out infinite;
    }

    @media (prefers-reduced-motion: reduce) {
        svg {
            animation: none;
        }
    }
`;

export const Title = styled.div`
    font-size: 26px;
    font-weight: 700;
    line-height: 1.25;
    max-width: 300px;
`;

export const Message = styled.div`
    margin-top: 12px;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.5;
    max-width: 300px;
    color: rgba(255, 255, 255, 0.82);
    white-space: pre-line;
    text-align: left;
`;

export const StatPill = styled.div`
    margin-top: 20px;
    max-width: 220px;
    padding: 10px 18px;
    border-radius: 14px;
    background-color: rgba(255, 255, 255, 0.12);
    font-size: 16px;
    font-weight: 600;
    line-height: 1.35;
    letter-spacing: 0.2px;
    text-align: center;
`;

export const DismissButton = styled.button`
    margin-top: 32px;
    min-width: 220px;
    padding: 12px 24px;
    border: none;
    border-radius: 24px;
    background-color: ${colors.green.flashygreen};
    color: ${colors.white.basic};
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
        background-color: ${colors.green.aquamarine};
    }
`;
